import './Lists.css'
import React from 'react'

let origin = window.location.origin
origin = origin.replace(/:3000/, '')

class Lists extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lists: null,
      viewingList: null
    }
  }

  componentDidMount = () => {
    this.getLists()
  }

  render = () => {
    if (this.state.lists === null) {
      return <div className='lists' />
    }
    else if (this.state.viewingList === null) {
      const listNames = this.state.lists.map(l => l.name)
      return (
        <ViewLists
          names={listNames}
          viewList={this.viewList}
          addList={this.addList}
        />
      )
    }
    else {
      const list = this.state.lists[this.state.viewingList]
      return (
        <ListPage
          name={list.name}
          content={list.content}
          toggleChecked={this.toggleChecked}
          deleteItem={this.deleteItem}
          addItem={this.addItem}
          deleteList={this.deleteList}
          goBack={this.closeList}
        />
      )
    }
  }

  viewList = (index) => {
    this.setState({ viewingList: index })
  }

  closeList = async () => {
    await this.postList(this.state.viewingList)
    this.setState({ viewingList: null })
  }

  addItem = async (itemName) => {
    const lists = this.state.lists
    lists[this.state.viewingList].content.push({ checked: false, value: itemName })
    this.setState({ lists: lists })
    await this.postList(this.state.viewingList)
  }

  deleteItem = (index) => {
    const lists = this.state.lists
    lists[this.state.viewingList].content.splice(index, 1);
    this.setState({ lists: lists })
  }

  toggleChecked = (index) => {
    const lists = this.state.lists
    const checked = lists[this.state.viewingList].content[index].checked
    lists[this.state.viewingList].content[index].checked = !checked
    this.setState({ lists: lists })
  }

  addList = async (listName) => {
    const existingIndex = this.state.lists.map(l => l.name).indexOf(listName)
    if (existingIndex !== -1) {
      this.viewList(existingIndex)
      return
    }

    const response = await fetch(`${origin}/api/shopping_list/add_list`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username: this.props.username,
        token: this.props.token,
        name: listName
      })
    })

    if (response.ok) {
      await this.getLists()
    }
    else {
      this.props.bootToLogin()
    }
  }

  deleteList = async () => {
    const listName = this.state.lists[this.state.viewingList].name
    
    const response = await fetch(`${origin}/api/shopping_list/delete_list`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username: this.props.username,
        token: this.props.token,
        name: listName
      })
    })
    
    this.state.viewingList = null
    if (response.ok) {
      await this.getLists()
    }
    else {
      this.props.bootToLogin()
    }
  }

  getLists = async () => {
    const response = await fetch(`${origin}/api/shopping_list/get_lists`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username: this.props.username,
        token: this.props.token,
      })
    })

    if (response.ok) {
      this.setState({ lists: await response.json().then(r => r.lists) })
    }
    else {
      this.props.bootToLogin()
    }
  }

  postList = async (index) => {
    const list = this.state.lists[index]
    const response = await fetch(`${origin}/api/shopping_list/update_list`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username: this.props.username,
        token: this.props.token,
        name: list.name,
        values: list.content
      })
    })

    if (response.ok) {
      this.getLists()
    }
    else {
      this.props.bootToLogin()
    }
  }
}

class ViewLists extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      addingList: false
    }
  }

  render = () => {
    return (
      <div className='lists'>
        <div className='title'>Lists</div>
        {this.props.names.map(this.renderList)}
        {
          this.state.addingList
            ? <input id='add-list-input' type='text' onKeyUp={this.endAddList} autoComplete='off' />
            : <></>
        }
        <button onClick={this.startAddList}>Add list.</button>
      </div>
    )
  }

  renderList = (listName, index) => {
    return (
      <div key={listName} className='listname' onClick={() => { this.openList(index) }}>
        {listName}
      </div>
    )
  }

  openList = (index) => {
    this.props.viewList(index)
  }

  startAddList = () => {
    if (!this.state.addingList) {
      this.setState({ addingList: true })
    }
    else {
      this.endAddList()
    }
  }

  endAddList = (e) => {
    if (e?.type === 'keyup' && !(e.key === 'Enter')) return
    this.setState({ addingList: false })
    
    const listName = document.getElementById('add-list-input').value
    if (listName) {
      this.props.addList(listName)
    }
  }
}

class ListPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      addingItem: false
    }
  }

  render = () => {
    return (
      <div className='listpage'>
        <div className='title'>{this.props.name}</div>
        {this.props.content.map(this.renderItem)}
        {
          this.state.addingItem
            ? <input id='add-item-input' type='text' onKeyUp={this.endAddItem} autoComplete='off' />
            : <></>
        }
        <button onClick={this.startAddItem}>Add item.</button>
        <button onClick={this.props.deleteList}>Delete list.</button>
        <button onClick={this.props.goBack}>Back.</button>
      </div>
    )
  }

  renderItem = (content, index) => {
    return (
      <div
        key={index}
        className='listelement'
        style={{ color: content.checked ? 'gray' : null }}
        onClick={() => { this.props.toggleChecked(index) }}
        onContextMenu={(e) => {e.preventDefault(); this.props.deleteItem(index)}}
      >
        {content.checked ? <s>{content.value}</s> : content.value}
      </div>
    )
  }

  startAddItem = () => {
    if (!this.state.addingItem) {
      this.setState({ addingItem: true })
    }
    else {
      this.endAddItem()
    }
  }

  endAddItem = (e) => {
    if (e?.type === 'keyup' && !(e.key === 'Enter')) return
    this.setState({ addingItem: false })
    
    const itemName = document.getElementById('add-item-input').value
    if (itemName) {
      this.props.addItem(itemName)
    }
  }
}

export default Lists
